import React, {useState, useEffect} from 'react';
import Loan from './Loan';
import Return from './Return';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            {children}
          </Box>
        )}
      </div>
    );
}
function a11yProps(index) {
    return {
      id: `user-tab-${index}`,
      'aria-controls': `user-tabpanel-${index}`,
    };
}
export default function Loans(props) {
  const classes = useStyles();
    useEffect(() => {
        if(props.role.account.idToken.roles[0] === "Returns")
        {
          setTabIndex(1);
        }
      },[props.role.account.idToken.roles]);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    const [tabIndex, setTabIndex] = useState(0);

    return (
      <main className={classes.content}>
      <div className={classes.appBarSpacer} />
        <Tabs value={tabIndex} centered onChange={handleTabChange} aria-label="Student Laptop Loans">
            <Tab label="Loan Equipment" disabled={props.role.account.idToken.roles[0] === "Returns"} {...a11yProps(0)} />
            <Tab label="Return Equipment" disabled={props.role.account.idToken.roles[0] !== "Returns" && props.role.account.idToken.roles[0] !== "AllPerms"} {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={tabIndex} index={0}>
            <Loan props={props.role}/>
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
            <Return />
        </TabPanel>
    </main>
    )
}
